import { Component, EventEmitter, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TopicAnswers } from '@app/_models';
import { CourseService } from '@app/_services/course.service';
import { TopicShareService } from '@app/_services/topic.share.service';

@Component({ selector: 'incourse-navigation', templateUrl: 'incourse-navigation.component.html' })
export class InCourseNavigationComponent {

    @Input() currentSectionId: any;
    @Input() theme: any;
    @Input() navigationData: any;

    onExitEvent: EventEmitter<any> = new EventEmitter<any>();

    sectionId: any;
    courseName: any;
    topicAnswers: TopicAnswers;
    valid: boolean;

    constructor(private route: ActivatedRoute, private router: Router, private shareService: TopicShareService, private courseService: CourseService) {
        this.shareService.emitter.subscribe((data: TopicAnswers) => {
            this.topicAnswers = data;
        });
    }

    getSectionLink(section) {
        return ['/course-section', section.id.toString()];
    }

    ngOnInit() {       
        
        this.route.paramMap.subscribe(params => {
            this.sectionId = params.get('id');
        });
      
     
        
    }

     onExitCourse(){

        this.onExitEvent.emit();
    
    }
}